import type { DatasetMetadata } from '../types/QueryTypes';
export const REQUEST_METADATA: DatasetMetadata = {
  fields: {
    datasetType: {
      type: 'string',
      datasets: ['request'],
      description: 'Dataset discriminator',
      synonyms: ['type', 'kind']
    },
    id: {
      type: 'string',
      datasets: ['request'],
      description: 'Unique identifier',
      synonyms: ['id', 'deal id', 'dr id', 'request id']
    },
    account: {
      type: 'string',
      datasets: ['request'],
      description: 'Customer account name',
      synonyms: ['account', 'company', 'customer', 'client']
    },
    sc: {
      type: 'string',
      datasets: ['request'],
      description: 'Solution consultant assigned',
      synonyms: ['sc', 'consultant', 'solution consultant', 'owner']
    },
    status: {
      type: 'enum',
      datasets: ['request'],
      description: 'Request status',
      synonyms: ['status', 'state', 'stage'],
      enumValues: ['In Progress', 'Closed', 'On Hold', 'Cancelled']
    },
    status_eq: {
      type: 'string',
      datasets: ['request'],
      description: 'Status short code',
      synonyms: ['status code', 'status eq']
    },
    age: {
      type: 'number',
      datasets: ['request'],
      description: 'Days since entry',
      synonyms: ['age', 'days', 'duration']
    },
    gnarr: {
      type: 'number',
      datasets: ['request'],
      description: 'Annual recurring revenue',
      synonyms: ['gnarr', 'revenue', 'amount', 'value', 'arr', 'recurring revenue']
    },
    region: {
      type: 'string',
      datasets: ['request'],
      description: 'Geographic region',
      synonyms: ['region', 'geo', 'geography']
    },
    sub_region: {
      type: 'string',
      datasets: ['request'],
      description: 'Sub-region or territory',
      synonyms: ['sub region', 'sub-region', 'subregion', 'territory']
    },
    close_q: {
      type: 'string',
      datasets: ['request'],
      description: 'Expected close quarter',
      synonyms: ['close quarter', 'close q', 'quarter']
    },
    offering: {
      type: 'string',
      datasets: ['request'],
      description: 'Engagement type',
      synonyms: ['offering', 'solution', 'package']
    },
    requestName: {
      type: 'string',
      datasets: ['request'],
      description: 'Request or deal name',
      synonyms: ['request name', 'deal name', 'opportunity name', 'request']
    },
    requestID: {
      type: 'string',
      datasets: ['request'],
      description: 'Request registration ID',
      synonyms: ['request id', 'dr id']
    },
    products: {
      type: 'string',
      datasets: ['request'],
      description: 'Adobe products involved',
      synonyms: ['products', 'product', 'solutions', 'tools']
    },
    entry: {
      type: 'string',
      datasets: ['request'],
      description: 'Entry date',
      synonyms: ['entry', 'entry date', 'start date']
    },
    completion: {
      type: 'string',
      datasets: ['request'],
      description: 'Completion date',
      synonyms: ['completion', 'completion date', 'end date']
    },
    sales_region: {
      type: 'string',
      datasets: ['request'],
      description: 'Sales region',
      synonyms: ['sales region', 'sales geo']
    },
    adjusted_commit: {
      type: 'string',
      datasets: ['request'],
      description: 'Commit status',
      synonyms: ['adjusted commit', 'commit', 'adjusted']
    },
    opp_status: {
      type: 'string',
      datasets: ['request'],
      description: 'Opportunity status',
      synonyms: ['opp status', 'opportunity status']
    },
    opp_gnarr: {
      type: 'number',
      datasets: ['request'],
      description: 'Opportunity revenue',
      synonyms: ['opp gnarr', 'opportunity gnarr', 'opportunity revenue']
    },
    created_q: {
      type: 'string',
      datasets: ['request'],
      description: 'Created quarter',
      synonyms: ['created quarter', 'created q']
    },
    created_fy: {
      type: 'string',
      datasets: ['request'],
      description: 'Created fiscal year',
      synonyms: ['created fy', 'created fiscal year', 'fiscal year']
    },
    raw_sub: {
      type: 'string',
      datasets: ['request'],
      description: 'Raw sub-region value',
      synonyms: ['raw sub', 'raw subregion']
    },
    segment: {
      type: 'string',
      datasets: ['request'],
      description: 'Business segment',
      synonyms: ['segment', 'business unit', 'bu']
    },
    segment_sales: {
      type: 'string',
      datasets: ['request'],
      description: 'Sales segment',
      synonyms: ['segment sales', 'sales segment']
    },
    market_area: {
      type: 'string',
      datasets: ['request'],
      description: 'Market area',
      synonyms: ['market area', 'market', 'market segment']
    }
  }
};
export const TOUCHPOINT_METADATA: DatasetMetadata = {
  fields: {
    datasetType: {
      type: 'string',
      datasets: ['touchpoint'],
      description: 'Dataset discriminator',
      synonyms: ['type', 'kind']
    },
    id: {
      type: 'string',
      datasets: ['touchpoint'],
      description: 'Unique identifier',
      synonyms: ['id', 'touchpoint id', 'task id']
    },
    name: {
      type: 'string',
      datasets: ['touchpoint'],
      description: 'Touchpoint name',
      synonyms: ['name', 'touchpoint name', 'task name', 'title']
    },
    account: {
      type: 'string',
      datasets: ['touchpoint'],
      description: 'Customer account name',
      synonyms: ['account', 'company', 'customer', 'client']
    },
    sc: {
      type: 'string',
      datasets: ['touchpoint'],
      description: 'Solution consultant assigned',
      synonyms: ['sc', 'consultant', 'solution consultant', 'owner']
    },
    status: {
      type: 'string',
      datasets: ['touchpoint'],
      description: 'Touchpoint status',
      synonyms: ['status', 'state', 'stage']
    },
    age: {
      type: 'number',
      datasets: ['touchpoint'],
      description: 'Days since entry',
      synonyms: ['age', 'days', 'duration']
    },
    gnarr: {
      type: 'number',
      datasets: ['touchpoint'],
      description: 'Annual recurring revenue',
      synonyms: ['gnarr', 'revenue', 'amount', 'value', 'arr', 'recurring revenue']
    },
    region: {
      type: 'string',
      datasets: ['touchpoint'],
      description: 'Geographic region',
      synonyms: ['region', 'geo', 'geography']
    },
    sub_region: {
      type: 'string',
      datasets: ['touchpoint'],
      description: 'Sub-region or territory',
      synonyms: ['sub region', 'sub-region', 'subregion', 'territory']
    },
    close_q: {
      type: 'string',
      datasets: ['touchpoint'],
      description: 'Close quarter',
      synonyms: ['close quarter', 'close q', 'quarter']
    },
    offering: {
      type: 'string',
      datasets: ['touchpoint'],
      description: 'Engagement type',
      synonyms: ['offering', 'solution', 'package']
    },
    entry: {
      type: 'string',
      datasets: ['touchpoint'],
      description: 'Entry date',
      synonyms: ['entry', 'entry date', 'start date']
    },
    completion: {
      type: 'string',
      datasets: ['touchpoint'],
      description: 'Completion date',
      synonyms: ['completion', 'completion date', 'end date']
    },
    actualStartDate: {
      type: 'string',
      datasets: ['touchpoint'],
      description: 'Actual start date',
      synonyms: ['start date', 'actual start', 'begin date']
    },
    task_id: {
      type: 'string',
      datasets: ['touchpoint'],
      description: 'Task identifier',
      synonyms: ['task id', 'task id']
    },
    touchpointType: {
      type: 'string',
      datasets: ['touchpoint'],
      description: 'Type of touchpoint activity',
      synonyms: ['touchpoint type', 'type', 'activity type', 'meeting type']
    },
    solutionComments: {
      type: 'string',
      datasets: ['touchpoint'],
      description: 'Raw DraftJS comments',
      synonyms: ['solution comments', 'raw comments']
    },
    commentText: {
      type: 'string',
      datasets: ['touchpoint'],
      description: 'Plain text comments',
      synonyms: ['comment text', 'comments', 'notes', 'description']
    },
    market_area: {
      type: 'string',
      datasets: ['touchpoint'],
      description: 'Market area',
      synonyms: ['market area', 'market', 'market segment']
    },
    segment: {
      type: 'string',
      datasets: ['touchpoint'],
      description: 'Business segment',
      synonyms: ['segment', 'business unit', 'bu']
    },
    segment_sales: {
      type: 'string',
      datasets: ['touchpoint'],
      description: 'Sales segment',
      synonyms: ['segment sales', 'sales segment']
    },
    raw_sub: {
      type: 'string',
      datasets: ['touchpoint'],
      description: 'Raw sub-region value',
      synonyms: ['raw sub', 'raw subregion']
    },
    created_fy: {
      type: 'string',
      datasets: ['touchpoint'],
      description: 'Created fiscal year',
      synonyms: ['created fy', 'created fiscal year', 'fiscal year']
    },
    created_q: {
      type: 'string',
      datasets: ['touchpoint'],
      description: 'Created quarter',
      synonyms: ['created quarter', 'created q']
    },
    opp_gnarr: {
      type: 'number',
      datasets: ['touchpoint'],
      description: 'Opportunity revenue',
      synonyms: ['opp gnarr', 'opportunity gnarr', 'opportunity revenue']
    }
  }
};
export const ALL_FIELDS: Record<string, {
  type: string;
  datasets: string[];
  synonyms: string[];
}> = (() => {
  const merged: Record<string, {
    type: string;
    datasets: string[];
    synonyms: string[];
  }> = {};
  for (const [name, meta] of Object.entries(REQUEST_METADATA.fields)) {
    if (name === 'datasetType') continue;
    merged[name] = {
      ...meta,
      datasets: [...meta.datasets]
    };
  }
  for (const [name, meta] of Object.entries(TOUCHPOINT_METADATA.fields)) {
    if (name === 'datasetType') continue;
    if (merged[name]) {
      for (const ds of meta.datasets) {
        if (!merged[name].datasets.includes(ds)) merged[name].datasets.push(ds);
      }
    } else {
      merged[name] = {
        ...meta,
        datasets: [...meta.datasets]
      };
    }
  }
  return merged;
})();